var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedinOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 45.044 45.044",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_726",
    "data-name": "\\u7EC4 726",
    transform: "translate(-3331.92 -395.318)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_725",
    "data-name": "\\u7EC4 725"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84_331",
    "data-name": "\\u8DEF\\u5F84 331",
    d: "M3353.034,395.318h2.815a2.377,2.377,0,0,0,.339.072,21.449,21.449,0,0,1,9.781,3.11,22.231,22.231,0,0,1,10.649,15.459c.152.818.232,1.649.346,2.473v2.816c-.037.288-.077.577-.108.866a22.581,22.581,0,0,1-18.492,19.9c-.832.151-1.676.234-2.515.349h-2.815c-.549-.068-1.1-.127-1.649-.2a22.572,22.572,0,0,1-19.115-18.393c-.151-.832-.235-1.677-.35-2.516v-2.816c.036-.288.075-.576.107-.865a22.566,22.566,0,0,1,18.579-19.909C3351.41,395.518,3352.224,395.43,3353.034,395.318Zm3.381,34.031c0-1.417-.005-2.793,0-4.169.007-1.861,0-3.723.041-5.584a2.824,2.824,0,0,1,1.378-2.33,2.639,2.639,0,0,1,4.109,1.481,7.358,7.358,0,0,1,.234,1.907c.025,2.741.011,5.482.011,8.223v.459h5.464c.007-.144.018-.26.018-.376,0-3.005.006-6.01-.006-9.014a15.9,15.9,0,0,0-.116-1.8c-.384-3.231-2.318-5.271-5.43-5.626a5.455,5.455,0,0,0-5.475,2.347,3.065,3.065,0,0,1-.229.246c0-.68-.016-1.262.007-1.843.013-.325-.087-.429-.42-.426-1.568.017-3.136.007-4.705.009a3.091,3.091,0,0,0-.335.034v16.459Zm-8.534,0c.009-.112.021-.183.021-.254q0-7.938.008-15.877c0-.342-.154-.373-.426-.371-1.554.008-3.108,0-4.662,0-.128,0-.255.019-.383.029v16.468Zm-5.784-21.59a2.846,2.846,0,0,0,3.064,2.851,2.861,2.861,0,1,0,.043-5.706A2.856,2.856,0,0,0,3342.1,407.763Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinOutlined);
export default __webpack_public_path__ + "static/media/linkedin_outlined.624a04dd3f67d729befaa4927c26495e.svg";
export { ForwardRef as ReactComponent };